export const upcomingEvents = [
    {
        "id": "6f8c4e30-a4b9-4a30-9d4f-530530ca52ac",
        "title": "Sri Rama Navami",
        "date": "2026-03-27",
        "location": "Sri Bhimanakatte Matha, Thirthahalli",
        "description": "Grand celebration of the divine birth of Lord Sri Rama with special poojas, pravachana and mahamangalarati on the banks of river Tunga.",
        "image": "/assets/pmpv546s_ramnavami.jpg",
        "is_upcoming": true,
        "order": 1,
        "description_kn": "ತುಂಗಾ ನದಿಯ ತೀರದಲ್ಲಿ ವಿಶೇಷ ಪೂಜೆ, ಪ್ರವಚನ ಹಾಗೂ ಮಹಾಮಂಗಳಾರತಿಯೊಂದಿಗೆ ಶ್ರೀರಾಮನ ದಿವ್ಯ ಜನ್ಮೋತ್ಸವದ ಭವ್ಯ ಆಚರಣೆ.",
        "description_sa": "तुङ्गानदीतीरे विशेषपूजाभिः प्रवचनेन महामङ्गलारत्या च श्रीरामस्य दिव्यजन्मोत्सवस्य भव्यम् आचरणम्।",
        "location_kn": "ಶ್ರೀ ಭೀಮನಕಟ್ಟೆ ಮಠ, ತೀರ್ಥಹಳ್ಳಿ",
        "location_sa": "श्री भीमनकट्टे मठः, तीर्थहळ्ळी",
        "title_kn": "ಶ್ರೀ ರಾಮ ನವಮಿ",
        "title_sa": "श्री रामनवमी"
    },
    {
        "id": "2318c961-d9aa-47d3-a13a-5dad62a970fd",
        "title": "Sri Narasimha Jayanti",
        "date": "2026-05-11",
        "location": "Sri Bhimanakatte Matha",
        "description": "Ugra-Narasimha aradhana with special abhisheka, homa and annadana in the sannidhi.",
        "image": "/assets/ehmgnazo_diety1.jpg",
        "is_upcoming": true,
        "order": 2,
        "description_kn": "ಸನ್ನಿಧಿಯಲ್ಲಿ ವಿಶೇಷ ಅಭಿಷೇಕ, ಹೋಮ ಹಾಗೂ ಅನ್ನದಾನದೊಂದಿಗೆ ಉಗ್ರನರಸಿಂಹ ಆರಾಧನೆ.",
        "description_sa": "सन्निधौ विशेषाभिषेकेण होमेन अन्नदानेन च उग्रनरसिंहाराधनम्।",
        "location_kn": "ಶ್ರೀ ಭೀಮನಕಟ್ಟೆ ಮಠ",
        "location_sa": "श्री भीमनकट्टे मठः",
        "title_kn": "ಶ್ರೀ ನರಸಿಂಹ ಜಯಂತಿ",
        "title_sa": "श्री नरसिंहजयन्ती"
    },
    {
        "id": "b1e061d5-05fa-4092-a2a4-5797b311cf4d",
        "title": "Sri Krishna Janmashtami",
        "date": "2026-08-16",
        "location": "Sri Bhimanakatte Matha",
        "description": "Nishita kala pooja to Sri Krishna followed by uriyadi, bhajans and mahamangalarati.",
        "image": "/assets/n0mtazl3_diety3.jpeg",
        "is_upcoming": true,
        "order": 3,
        "description_kn": "ನಿಶಿತ ಕಾಲದಲ್ಲಿ ಶ್ರೀಕೃಷ್ಣ ಪೂಜೆ, ನಂತರ ಉರಿಯಡಿ, ಭಜನೆ ಹಾಗೂ ಮಹಾಮಂಗಳಾರತಿ.",
        "description_sa": "निशीथकाले श्रीकृष्णपूजा, ततः उरियडि-भजनानि महामङ्गलारतिश्च।",
        "location_kn": "ಶ್ರೀ ಭೀಮನಕಟ್ಟೆ ಮಠ",
        "location_sa": "श्री भीमनकट्टे मठः",
        "title_kn": "ಶ್ರೀ ಕೃಷ್ಣ ಜನ್ಮಾಷ್ಟಮಿ",
        "title_sa": "श्री कृष्णजन्माष्टमी"
    },
    {
        "id": "3aa1295c-a1e7-4c8b-bc9b-07bbd2d45d4c",
        "title": "Sharannavaratri",
        "date": "2026-10-11",
        "location": "Sri Bhimanakatte Matha",
        "description": "Nine nights of Devi aradhana — Chandika Homa, Sri Sukta parayana, and daily alankaras.",
        "image": "https://images.unsplash.com/photo-1604608672516-f1b9c3a97fdf?auto=format&fit=crop&w=1200&q=80",
        "is_upcoming": true,
        "order": 4,
        "description_kn": "ಒಂಬತ್ತು ರಾತ್ರಿಗಳ ದೇವೀ ಆರಾಧನೆ — ಚಂಡಿಕಾ ಹೋಮ, ಶ್ರೀಸೂಕ್ತ ಪಾರಾಯಣ ಹಾಗೂ ನಿತ್ಯ ಅಲಂಕಾರಗಳು.",
        "description_sa": "नवरात्रिषु देवी-आराधनम् — चण्डिकाहोमः, श्रीसूक्तपारायणं, प्रतिदिनम् अलङ्काराश्च।",
        "location_kn": "ಶ್ರೀ ಭೀಮನಕಟ್ಟೆ ಮಠ",
        "location_sa": "श्री भीमनकट्टे मठः",
        "title_kn": "ಶರನ್ನವರಾತ್ರಿ",
        "title_sa": "शरन्नवरात्रम्"
    },
    {
        "id": "01a82fe2-2118-4285-952b-3c46fcb1a2d8",
        "title": "Karthika Deepotsava",
        "date": "2026-11-14",
        "location": "Sri Bhimanakatte Matha",
        "description": "The sacred month of Karthika illuminated by thousands of diyas at the Matha and on the banks of Tunga.",
        "image": "https://images.pexels.com/photos/34431714/pexels-photo-34431714.jpeg?auto=compress&cs=tinysrgb&w=1200",
        "is_upcoming": true,
        "order": 5,
        "description_kn": "ಪವಿತ್ರ ಕಾರ್ತಿಕ ಮಾಸದಲ್ಲಿ ಮಠದಲ್ಲಿ ಹಾಗೂ ತುಂಗಾ ತೀರದಲ್ಲಿ ಸಾವಿರಾರು ದೀಪಗಳ ಬೆಳಕು.",
        "description_sa": "पवित्रे कार्तिकमासे मठे तुङ्गातीरे च सहस्रदीपैः प्रकाशितम्।",
        "location_kn": "ಶ್ರೀ ಭೀಮನಕಟ್ಟೆ ಮಠ",
        "location_sa": "श्री भीमनकट्टे मठः",
        "title_kn": "ಕಾರ್ತಿಕ ದೀಪೋತ್ಸವ",
        "title_sa": "कार्तिकदीपोत्सवः"
    },
    {
        "id": "b34e3cac-8bc3-4e8f-a426-0c4e16b824d8",
        "title": "Sri Achyuthapreksharu Aaradhana",
        "date": "2026-01-14",
        "location": "Sri Bhimanakatte Matha",
        "description": "Annual aradhana of the founding acharya Sri Achyuthapreksharu observed with vedic honors.",
        "image": "/assets/7a5qi4sr_3.jpg",
        "is_upcoming": true,
        "order": 6,
        "description_kn": "ಸಂಸ್ಥಾಪಕ ಆಚಾರ್ಯ ಶ್ರೀ ಅಚ್ಯುತಪ್ರೇಕ್ಷರ ವಾರ್ಷಿಕ ಆರಾಧನೆ ವೈದಿಕ ಗೌರವಗಳೊಂದಿಗೆ.",
        "description_sa": "संस्थापकाचार्यस्य श्री अच्युतप्रेक्षस्य वार्षिकाराधना वैदिकसम्मानैः।",
        "location_kn": "ಶ್ರೀ ಭೀಮನಕಟ್ಟೆ ಮಠ",
        "location_sa": "श्री भीमनकट्टे मठः",
        "title_kn": "ಶ್ರೀ ಅಚ್ಯುತಪ್ರೇಕ್ಷರ ಆರಾಧನೆ",
        "title_sa": "श्री अच्युतप्रेक्षाराधना"
    }
];

export const galleryItems = [
    {
        "id": "a97844ed-d72f-4b20-aabf-bbd729399bce",
        "title": "The Matha at Bhimanakatte",
        "category": "Matha",
        "image": "/assets/0fhsal4g_collage1.jpeg",
        "order": 0,
        "category_kn": "ಮಠ",
        "category_sa": "मठः",
        "title_kn": "ಭೀಮನಕಟ್ಟೆಯ ಮಠ",
        "title_sa": "भीमनकट्टे मठः"
    },
    {
        "id": "a4e2f049-252f-42f6-9f10-21d822b7efa2",
        "title": "Pujyaraya on the sacred banks of Tunga",
        "category": "Matha",
        "image": "/assets/1dws6svy_1.jpeg",
        "order": 1,
        "category_kn": "ಮಠ",
        "category_sa": "मठः",
        "title_kn": "ತುಂಗಾ ತೀರದಲ್ಲಿ ಪೂಜ್ಯರಾಯರು",
        "title_sa": "तुङ्गातीरे पूज्यपादाः"
    },
    {
        "id": "ce2df8c0-4e9c-4fee-8ac0-7c84437a7e68",
        "title": "Deepotsava on the banks of Tunga",
        "category": "Festivals",
        "image": "https://images.pexels.com/photos/34431714/pexels-photo-34431714.jpeg?auto=compress&cs=tinysrgb&w=1200",
        "order": 2,
        "category_kn": "ಉತ್ಸವಗಳು",
        "category_sa": "उत्सवाः",
        "title_kn": "ತುಂಗಾ ತೀರದಲ್ಲಿ ದೀಪೋತ್ಸವ",
        "title_sa": "तुङ्गातीरे दीपोत्सवः"
    },
    {
        "id": "cdbd5d64-1ded-45e6-9636-3baeeed4c75b",
        "title": "Aradhana Mahotsava — grace of the Peethaadhipati",
        "category": "Festivals",
        "image": "/assets/qwifoqub_4.jpg",
        "order": 3,
        "category_kn": "ಉತ್ಸವಗಳು",
        "category_sa": "उत्सवाः",
        "title_kn": "ಆರಾಧನಾ ಮಹೋತ್ಸವ — ಪೀಠಾಧಿಪತಿಗಳ ಅನುಗ್ರಹ",
        "title_sa": "आराधनामहोत्सवः — पीठाधिपतेः अनुग्रहः"
    },
    {
        "id": "f00db113-aea9-4f01-8978-c975cb50157c",
        "title": "H.H. Sri Raghuvarendra Teertha Swamiji",
        "category": "Pontiffs",
        "image": "/assets/zh6ml123_current_pontiff.jpeg",
        "order": 4,
        "category_kn": "ಪೀಠಾಧಿಪತಿಗಳು",
        "category_sa": "पीठाधिपतयः",
        "title_kn": "ಶ್ರೀ ರಘುವರೇಂದ್ರ ತೀರ್ಥ ಸ್ವಾಮೀಜಿ",
        "title_sa": "श्री रघुवरेन्द्रतीर्थस्वामिनः"
    },
    {
        "id": "fecc8c4e-517f-4edd-a110-b28ead60c66b",
        "title": "H.H. Sri Raghumanya Teertha Swamiji",
        "category": "Pontiffs",
        "image": "/assets/y07jqmxh_previous_pontiff.png",
        "order": 5,
        "category_kn": "ಪೀಠಾಧಿಪತಿಗಳು",
        "category_sa": "पीठाधिपतयः",
        "title_kn": "ಶ್ರೀ ರಘುಮಾನ್ಯ ತೀರ್ಥ ಸ್ವಾಮೀಜಿ",
        "title_sa": "श्री रघुमान्यतीर्थस्वामिनः"
    },
    {
        "id": "ef7c07ea-1eb7-4c88-9d1f-bd11bb08aab3",
        "title": "Naivedya samarpana at the sannidhi",
        "category": "Annadana",
        "image": "/assets/m2kssnw9_5.jpeg",
        "order": 6,
        "category_kn": "ಅನ್ನದಾನ",
        "category_sa": "अन्नदानम्",
        "title_kn": "ಸನ್ನಿಧಿಯಲ್ಲಿ ನೈವೇದ್ಯ ಸಮರ್ಪಣೆ",
        "title_sa": "सन्निधौ नैवेद्यसमर्पणम्"
    },
    {
        "id": "8b423713-a150-436d-a8dc-6519a91a050e",
        "title": "Golden vigrahas adorned with jasmine garlands",
        "category": "Annadana",
        "image": "/assets/p9p4fjxq_6.jpg",
        "order": 7,
        "category_kn": "ಅನ್ನದಾನ",
        "category_sa": "अन्नदानम्",
        "title_kn": "ಮಲ್ಲಿಗೆ ಹಾರಗಳಿಂದ ಅಲಂಕೃತ ಸ್ವರ್ಣ ವಿಗ್ರಹಗಳು",
        "title_sa": "मल्लिकामालाभिः अलङ्कृताः स्वर्णविग्रहाः"
    },
    {
        "id": "d797a69b-fda1-4ca7-840b-600f239ca051",
        "title": "Sacred sanctum darshana",
        "category": "Go Shala",
        "image": "/assets/xzcs77cd_7.jpg",
        "order": 8,
        "category_kn": "ಗೋಶಾಲೆ",
        "category_sa": "गोशाला",
        "title_kn": "ಪವಿತ್ರ ಗರ್ಭಗುಡಿ ದರ್ಶನ",
        "title_sa": "पवित्रगर्भगृहदर्शनम्"
    },
    {
        "id": "987045c1-47d8-451a-bd6e-f2deccdf5232",
        "title": "Go Seva at dawn",
        "category": "Go Shala",
        "image": "https://images.unsplash.com/photo-1500595046743-cd271d694d30?auto=format&fit=crop&w=1200&q=80",
        "order": 9,
        "category_kn": "ಗೋಶಾಲೆ",
        "category_sa": "गोशाला",
        "title_kn": "ಮುಂಜಾನೆಯ ಗೋ ಸೇವೆ",
        "title_sa": "प्रभाते गोसेवा"
    },
    {
        "id": "d68d5600-8f01-45c9-899c-3087594addc8",
        "title": "Panchamrutha Abhisheka",
        "category": "Pooja",
        "image": "/assets/ehmgnazo_diety1.jpg",
        "order": 10,
        "category_kn": "ಪೂಜೆ",
        "category_sa": "पूजा",
        "title_kn": "ಪಂಚಾಮೃತ ಅಭಿಷೇಕ",
        "title_sa": "पञ्चामृताभिषेकः"
    },
    {
        "id": "bc2bee36-ec07-4105-bb21-6766670ca71e",
        "title": "Sacred silver idols",
        "category": "Pooja",
        "image": "/assets/n0mtazl3_diety3.jpeg",
        "order": 11,
        "category_kn": "ಪೂಜೆ",
        "category_sa": "पूजा",
        "title_kn": "ಪವಿತ್ರ ಬೆಳ್ಳಿ ವಿಗ್ರಹಗಳು",
        "title_sa": "पवित्ररजतविग्रहाः"
    },
    {
        "id": "3048fde1-df05-4510-bfa6-c3548dce6006",
        "title": "Deities of the Matha adorned with flowers",
        "category": "Pooja",
        "image": "/assets/ev8zy4nx_1.jpeg",
        "order": 12,
        "category_kn": "ಪೂಜೆ",
        "category_sa": "पूजा",
        "title_kn": "ಹೂವುಗಳಿಂದ ಅಲಂಕೃತ ಮಠದ ದೇವರುಗಳು",
        "title_sa": "पुष्पैः अलङ्कृताः मठदेवताः"
    },
    {
        "id": "738da55a-7f83-484a-aa87-b84368ece5c2",
        "title": "Bronze utsava vigrahas of the sannidhi",
        "category": "Pooja",
        "image": "/assets/7a5qi4sr_3.jpg",
        "order": 13,
        "category_kn": "ಪೂಜೆ",
        "category_sa": "पूजा",
        "title_kn": "ಸನ್ನಿಧಿಯ ಕಂಚಿನ ಉತ್ಸವ ವಿಗ್ರಹಗಳು",
        "title_sa": "सन्निधेः कांस्योत्सवविग्रहाः"
    },
    {
        "id": "8d8d50a7-bc27-424c-b750-ab704ba57341",
        "title": "Sanchara — devotee's home darshana",
        "category": "Sanchara",
        "image": "https://images.unsplash.com/photo-1583089892943-e02e5b017b6a?auto=format&fit=crop&w=1200&q=80",
        "order": 14,
        "category_kn": "ಸಂಚಾರ",
        "category_sa": "सञ्चारः",
        "title_kn": "ಸಂಚಾರ — ಭಕ್ತರ ಮನೆ ದರ್ಶನ",
        "title_sa": "सञ्चारः — भक्तगृहदर्शनम्"
    },
    {
        "id": "bd510809-00e4-4d12-9993-8c18255c576e",
        "title": "Vidwat Sabha in Bengaluru",
        "category": "Sanchara",
        "image": "https://images.unsplash.com/photo-1571680322279-a226e6a4cc2a?auto=format&fit=crop&w=1200&q=80",
        "order": 15,
        "category_kn": "ಸಂಚಾರ",
        "category_sa": "सञ्चारः",
        "title_kn": "ಬೆಂಗಳೂರಿನಲ್ಲಿ ವಿದ್ವತ್ ಸಭೆ",
        "title_sa": "बेङ्गळूरुनगरे विद्वत्सभा"
    }
];

export const youtubeVideos = {
    "channel_id": "UC3J8UikcNsQudSfxXLZOEYA",
    "channel_url": "https://www.youtube.com/@sribhimanakattematha1339",
    "videos": [
        {
            "id": "OtTjprIOnSQ",
            "title": "Cordial invite for Aradhana Mahotsava of HH Sri Raghumanya Theertaru",
            "thumbnail": "https://i.ytimg.com/vi/OtTjprIOnSQ/hqdefault.jpg",
            "url": "https://www.youtube.com/watch?v=OtTjprIOnSQ",
            "published": "2024-05-01"
        },
        {
            "id": "YEq6MNSrKao",
            "title": "ಪರಮಪೂಜ್ಯ ಶ್ರೀ ಶ್ರೀರಘುಮಾನ್ಯತೀರ್ಥ ಶ್ರೀಪಾದರ ಜೀವನದ ಸವಿನೆನಪುಗಳು",
            "thumbnail": "https://i.ytimg.com/vi/YEq6MNSrKao/hqdefault.jpg",
            "url": "https://www.youtube.com/watch?v=YEq6MNSrKao",
            "published": "2024-04-20"
        },
        {
            "id": "sK7ZfL5G3fY",
            "title": "Aaradhana Mahotsava — Sanctified Rituals at the Matha",
            "thumbnail": "https://i.ytimg.com/vi/sK7ZfL5G3fY/hqdefault.jpg",
            "url": "https://www.youtube.com/@sribhimanakattematha1339",
            "published": "2024-03-15"
        }
    ]
}

export const paramparaList = [
    {
        "id": "71293131-d797-4695-8ae1-ab7463cbd278",
        "name": "Sri Hamsa Namaka Paramatma",
        "period": "Divine & Munivrunda Lineage",
        "description": "",
        "image": null,
        "order": 1,
        "is_current": false,
        "is_featured": false,
        "section": "pre_madhwa",
        "seq": null,
        "name_kn": "ಶ್ರೀ ಹಂಸ ನಾಮಕ ಪರಮಾತ್ಮ",
        "name_sa": "श्री हंसनामकपरमात्मा",
        "period_kn": "ದಿವ್ಯ ಹಾಗೂ ಮುನಿವೃಂದ ಪರಂಪರೆ",
        "period_sa": "दिव्यमुनिवृन्दपरम्परा"
    },
    {
        "id": "fc672706-5b65-47c7-a7b9-8822f85f5f21",
        "name": "Sri Chaturmukha Brahma",
        "period": "Divine & Munivrunda Lineage",
        "description": "",
        "image": null,
        "order": 2,
        "is_current": false,
        "is_featured": false,
        "section": "pre_madhwa",
        "seq": null,
        "name_kn": "ಶ್ರೀ ಚತುರ್ಮುಖ ಬ್ರಹ್ಮ",
        "name_sa": "श्री चतुर्मुखब्रह्मा",
        "period_kn": "ದಿವ್ಯ ಹಾಗೂ ಮುನಿವೃಂದ ಪರಂಪರೆ",
        "period_sa": "दिव्यमुनिवृन्दपरम्परा"
    },
    {
        "id": "13470350-2c82-4466-beb8-72e970c1ce4a",
        "name": "Sri Sanakadi Rishis",
        "period": "Divine & Munivrunda Lineage",
        "description": "Sanaka, Sanandana, Sanatana, Sanatkumara",
        "image": null,
        "order": 3,
        "is_current": false,
        "is_featured": false,
        "section": "pre_madhwa",
        "seq": null,
        "name_kn": "ಶ್ರೀ ಸನಕಾದಿ ಋಷಿಗಳು",
        "name_sa": "श्री सनकादयः ऋषयः",
        "period_kn": "ದಿವ್ಯ ಹಾಗೂ ಮುನಿವೃಂದ ಪರಂಪರೆ",
        "period_sa": "दिव्यमुनिवृन्दपरम्परा",
        "description_kn": "ಸನಕ, ಸನಂದನ, ಸನಾತನ, ಸನತ್ಕುಮಾರ",
        "description_sa": "सनकः सनन्दनः सनातनः सनत्कुमारः"
    },
    {
        "id": "09da73ab-a9d6-4b59-b90e-c10d1da5094c",
        "name": "Sri Durvasa Rishi",
        "period": "Divine & Munivrunda Lineage",
        "description": "",
        "image": null,
        "order": 4,
        "is_current": false,
        "is_featured": false,
        "section": "pre_madhwa",
        "seq": null,
        "name_kn": "ಶ್ರೀ ದೂರ್ವಾಸ ಋಷಿ",
        "name_sa": "श्री दुर्वासा ऋषिः",
        "period_kn": "ದಿವ್ಯ ಹಾಗೂ ಮುನಿವೃಂದ ಪರಂಪರೆ",
        "period_sa": "दिव्यमुनिवृन्दपरम्परा"
    },
    {
        "id": "d8fd9876-6c16-4bf0-b8ef-012af6086704",
        "name": "Sri Jnananidhi Teertha",
        "period": "Divine & Munivrunda Lineage",
        "description": "",
        "image": null,
        "order": 5,
        "is_current": false,
        "is_featured": false,
        "section": "pre_madhwa",
        "seq": null,
        "name_kn": "ಶ್ರೀ ಜ್ಞಾನನಿಧಿ ತೀರ್ಥರು",
        "name_sa": "श्री ज्ञाननिधितीर्थः",
        "period_kn": "ದಿವ್ಯ ಹಾಗೂ ಮುನಿವೃಂದ ಪರಂಪರೆ",
        "period_sa": "दिव्यमुनिवृन्दपरम्परा"
    },
    {
        "id": "44297544-fd79-48f0-b0da-f12d629285bf",
        "name": "Sri Garudavahana Teertha",
        "period": "Divine & Munivrunda Lineage",
        "description": "",
        "image": null,
        "order": 6,
        "is_current": false,
        "is_featured": false,
        "section": "pre_madhwa",
        "seq": null,
        "name_kn": "ಶ್ರೀ ಗರುಡವಾಹನ ತೀರ್ಥರು",
        "name_sa": "श्री गरुडवाहनतीर्थः",
        "period_kn": "ದಿವ್ಯ ಹಾಗೂ ಮುನಿವೃಂದ ಪರಂಪರೆ",
        "period_sa": "दिव्यमुनिवृन्दपरम्परा"
    },
    {
        "id": "92d796e1-38e5-41e7-9fbd-7d4beb92fc39",
        "name": "Sri Kaivalyanatha (Kaivalya) Teertha",
        "period": "Divine & Munivrunda Lineage",
        "description": "Recipient of land grant from King Janamejaya",
        "image": null,
        "order": 7,
        "is_current": false,
        "is_featured": false,
        "section": "pre_madhwa",
        "seq": null,
        "name_kn": "ಶ್ರೀ ಕೈವಲ್ಯನಾಥ (ಕೈವಲ್ಯ) ತೀರ್ಥರು",
        "name_sa": "श्री कैवल्यनाथ(कैवल्य)तीर्थः",
        "period_kn": "ದಿವ್ಯ ಹಾಗೂ ಮುನಿವೃಂದ ಪರಂಪರೆ",
        "period_sa": "दिव्यमुनिवृन्दपरम्परा",
        "description_kn": "ಜನಮೇಜಯ ರಾಜನಿಂದ ಭೂದಾನ ಪಡೆದವರು",
        "description_sa": "जनमेजयराजात् भूदानं प्राप्तवान्"
    },
    {
        "id": "7d254634-a6b5-44d8-8ef1-864358f26c03",
        "name": "Sri Jnanisha Teertha",
        "period": "Divine & Munivrunda Lineage",
        "description": "",
        "image": null,
        "order": 8,
        "is_current": false,
        "is_featured": false,
        "section": "pre_madhwa",
        "seq": null,
        "name_kn": "ಶ್ರೀ ಜ್ಞಾನೀಶ ತೀರ್ಥರು",
        "name_sa": "श्री ज्ञानीशतीर्थः",
        "period_kn": "ದಿವ್ಯ ಹಾಗೂ ಮುನಿವೃಂದ ಪರಂಪರೆ",
        "period_sa": "दिव्यमुनिवृन्दपरम्परा"
    },
    {
        "id": "d2016986-d248-4381-ac5e-742b794ed546",
        "name": "Sri Para Teertha",
        "period": "Divine & Munivrunda Lineage",
        "description": "",
        "image": null,
        "order": 9,
        "is_current": false,
        "is_featured": false,
        "section": "pre_madhwa",
        "seq": null,
        "name_kn": "ಶ್ರೀ ಪರ ತೀರ್ಥರು",
        "name_sa": "श्री परतीर्थः",
        "period_kn": "ದಿವ್ಯ ಹಾಗೂ ಮುನಿವೃಂದ ಪರಂಪರೆ",
        "period_sa": "दिव्यमुनिवृन्दपरम्परा"
    },
    {
        "id": "7a9adc23-5e30-4aaa-bac3-a6bae93fdf70",
        "name": "Sri Satyaprajna Teertha",
        "period": "Divine & Munivrunda Lineage",
        "description": "",
        "image": null,
        "order": 10,
        "is_current": false,
        "is_featured": false,
        "section": "pre_madhwa",
        "seq": null,
        "name_kn": "ಶ್ರೀ ಸತ್ಯಪ್ರಜ್ಞ ತೀರ್ಥರು",
        "name_sa": "श्री सत्यप्रज्ञतीर्थः",
        "period_kn": "ದಿವ್ಯ ಹಾಗೂ ಮುನಿವೃಂದ ಪರಂಪರೆ",
        "period_sa": "दिव्यमुनिवृन्दपरम्परा"
    },
    {
        "id": "32885ea1-7a40-4781-9a5b-d7a8c39c70db",
        "name": "Sri Prajna Teertha",
        "period": "Divine & Munivrunda Lineage",
        "description": "",
        "image": null,
        "order": 11,
        "is_current": false,
        "is_featured": false,
        "section": "pre_madhwa",
        "seq": null,
        "name_kn": "ಶ್ರೀ ಪ್ರಜ್ಞ ತೀರ್ಥರು",
        "name_sa": "श्री प्रज्ञतीर्थः",
        "period_kn": "ದಿವ್ಯ ಹಾಗೂ ಮುನಿವೃಂದ ಪರಂಪರೆ",
        "period_sa": "दिव्यमुनिवृन्दपरम्परा"
    },
    {
        "id": "a0dab96f-d59f-48cd-966d-dc9cd4b78b61",
        "name": "Sri Achyutaprekshacharya",
        "period": "Divine & Munivrunda Lineage",
        "description": "The Guru of Sri Madhwacharya",
        "image": null,
        "order": 12,
        "is_current": false,
        "is_featured": false,
        "section": "pre_madhwa",
        "seq": null,
        "name_kn": "ಶ್ರೀ ಅಚ್ಯುತಪ್ರೇಕ್ಷಾಚಾರ್ಯರು",
        "name_sa": "श्री अच्युतप्रेक्षाचार्यः",
        "period_kn": "ದಿವ್ಯ ಹಾಗೂ ಮುನಿವೃಂದ ಪರಂಪರೆ",
        "period_sa": "दिव्यमुनिवृन्दपरम्परा",
        "description_kn": "ಶ್ರೀ ಮಧ್ವಾಚಾರ್ಯರ ಗುರುಗಳು",
        "description_sa": "श्री मध्वाचार्यस्य गुरुः"
    },
    {
        "id": "5bd34943-4ad4-4871-92c8-ea42f6073548",
        "name": "Srimad Jagadguru Madhwacharya",
        "period": "13th century · Founder of Tattvavada",
        "description": "The illustrious proponent of Tattvavada (Dvaita Vedanta) and disciple of Sri Achyutaprekshacharya. From his sacred sannyasa deeksha received in the sannidhi of Sri Achyutaprekshacharya, the post-Madhwa parampara of this Matha begins.",
        "image": "/assets/seur1hf7_Jagadguru_Sri_Madhvacharya.png",
        "order": 101,
        "is_current": false,
        "is_featured": true,
        "section": "post_madhwa",
        "seq": 1,
        "name_kn": "ಶ್ರೀಮದ್ ಜಗದ್ಗುರು ಮಧ್ವಾಚಾರ್ಯರು",
        "name_sa": "श्रीमद् जगद्गुरु मध्वाचार्यः",
        "period_kn": "೧೩ನೇ ಶತಮಾನ · ತತ್ತ್ವವಾದದ ಪ್ರವರ್ತಕರು",
        "period_sa": "त्रयोदशशतकम् · तत्त्ववादप्रवर्तकः",
        "description_kn": "ತತ್ತ್ವವಾದದ (ದ್ವೈತ ವೇದಾಂತ) ಪ್ರಖ್ಯಾತ ಪ್ರವರ್ತಕರು ಹಾಗೂ ಶ್ರೀ ಅಚ್ಯುತಪ್ರೇಕ್ಷಾಚಾರ್ಯರ ಶಿಷ್ಯರು. ಶ್ರೀ ಅಚ್ಯುತಪ್ರೇಕ್ಷಾಚಾರ್ಯರ ಸನ್ನಿಧಿಯಲ್ಲಿ ಪಡೆದ ಸಂನ್ಯಾಸ ದೀಕ್ಷೆಯಿಂದ ಈ ಮಠದ ಮಧ್ವೋತ್ತರ ಪರಂಪರೆ ಆರಂಭವಾಗುತ್ತದೆ.",
        "description_sa": "तत्त्ववादस्य (द्वैतवेदान्तस्य) प्रख्यातः प्रवर्तकः श्री अच्युतप्रेक्षाचार्यस्य शिष्यश्च। तस्य सन्निधौ प्राप्तया संन्यासदीक्षया अस्य मठस्य मध्वोत्तरपरम्परा आरभ्यते।"
    },
    {
        "id": "d30fdf87-0215-40a6-b9f1-059820dd531a",
        "name": "Sri Satyatirtha",
        "period": "Peetadhipathi",
        "description": "",
        "image": null,
        "order": 102,
        "is_current": false,
        "is_featured": false,
        "section": "post_madhwa",
        "seq": 2,
        "name_kn": "ಶ್ರೀ ಸತ್ಯತೀರ್ಥರು",
        "name_sa": "श्री सत्यतीर्थः",
        "period_kn": "ಪೀಠಾಧಿಪತಿ",
        "period_sa": "पीठाधिपतिः"
    },
    {
        "id": "5a99d3f3-2bdb-4c7a-9279-1856ff774ec2",
        "name": "Sri Satyavrata Teertha",
        "period": "Peetadhipathi",
        "description": "",
        "image": null,
        "order": 103,
        "is_current": false,
        "is_featured": false,
        "section": "post_madhwa",
        "seq": 3,
        "name_kn": "ಶ್ರೀ ಸತ್ಯವ್ರತ ತೀರ್ಥರು",
        "name_sa": "श्री सत्यव्रततीर्थः",
        "period_kn": "ಪೀಠಾಧಿಪತಿ",
        "period_sa": "पीठाधिपतिः"
    },
    {
        "id": "c1c03271-48db-4aef-b710-d169e75a00f2",
        "name": "Sri Vishwadhisha Teertha",
        "period": "Peetadhipathi",
        "description": "",
        "image": null,
        "order": 104,
        "is_current": false,
        "is_featured": false,
        "section": "post_madhwa",
        "seq": 4,
        "name_kn": "ಶ್ರೀ ವಿಶ್ವಾಧೀಶ ತೀರ್ಥರು",
        "name_sa": "श्री विश्वाधीशतीर्थः",
        "period_kn": "ಪೀಠಾಧಿಪತಿ",
        "period_sa": "पीठाधिपतिः"
    },
    {
        "id": "0263b08e-0244-4320-bb9a-4c46461ceb89",
        "name": "Sri Vidyadhisha Teertha",
        "period": "Peetadhipathi",
        "description": "",
        "image": null,
        "order": 105,
        "is_current": false,
        "is_featured": false,
        "section": "post_madhwa",
        "seq": 5,
        "name_kn": "ಶ್ರೀ ವಿದ್ಯಾಧೀಶ ತೀರ್ಥರು",
        "name_sa": "श्री विद्याधीशतीर्थः",
        "period_kn": "ಪೀಠಾಧಿಪತಿ",
        "period_sa": "पीठाधिपतिः"
    },
    {
        "id": "bd139d32-0e48-4d4a-9bb7-bed77731d12c",
        "name": "Sri Vishwamurthy Teertha",
        "period": "Peetadhipathi",
        "description": "",
        "image": null,
        "order": 106,
        "is_current": false,
        "is_featured": false,
        "section": "post_madhwa",
        "seq": 6,
        "name_kn": "ಶ್ರೀ ವಿಶ್ವಮೂರ್ತಿ ತೀರ್ಥರು",
        "name_sa": "श्री विश्वमूर्तितीर्थः",
        "period_kn": "ಪೀಠಾಧಿಪತಿ",
        "period_sa": "पीठाधिपतिः"
    },
    {
        "id": "1b665b6d-9970-4260-b886-4b8580385040",
        "name": "Sri Vishwapati Teertha",
        "period": "Peetadhipathi",
        "description": "",
        "image": null,
        "order": 107,
        "is_current": false,
        "is_featured": false,
        "section": "post_madhwa",
        "seq": 7,
        "name_kn": "ಶ್ರೀ ವಿಶ್ವಪತಿ ತೀರ್ಥರು",
        "name_sa": "श्री विश्वपतितीर्थः",
        "period_kn": "ಪೀಠಾಧಿಪತಿ",
        "period_sa": "पीठाधिपतिः"
    },
    {
        "id": "55b63889-1604-4a99-9a63-e3b7bb385387",
        "name": "Sri Vibudhesha Teertha",
        "period": "Peetadhipathi",
        "description": "",
        "image": null,
        "order": 108,
        "is_current": false,
        "is_featured": false,
        "section": "post_madhwa",
        "seq": 8,
        "name_kn": "ಶ್ರೀ ವಿಬುಧೇಶ ತೀರ್ಥರು",
        "name_sa": "श्री विबुधेशतीर्थः",
        "period_kn": "ಪೀಠಾಧಿಪತಿ",
        "period_sa": "पीठाधिपतिः"
    },
    {
        "id": "a74b70fc-16ec-4825-8298-2fe94fc99db8",
        "name": "Sri Vasudeva Teertha",
        "period": "Peetadhipathi",
        "description": "",
        "image": null,
        "order": 109,
        "is_current": false,
        "is_featured": false,
        "section": "post_madhwa",
        "seq": 9,
        "name_kn": "ಶ್ರೀ ವಾಸುದೇವ ತೀರ್ಥರು",
        "name_sa": "श्री वासुदेवतीर्थः",
        "period_kn": "ಪೀಠಾಧಿಪತಿ",
        "period_sa": "पीठाधिपतिः"
    },
    {
        "id": "9ab8a8fc-8f52-45c0-a583-dd456b326f0b",
        "name": "Sri Devagarbha Teertha",
        "period": "Peetadhipathi",
        "description": "",
        "image": null,
        "order": 110,
        "is_current": false,
        "is_featured": false,
        "section": "post_madhwa",
        "seq": 10,
        "name_kn": "ಶ್ರೀ ದೇವಗರ್ಭ ತೀರ್ಥರು",
        "name_sa": "श्री देवगर्भतीर्थः",
        "period_kn": "ಪೀಠಾಧಿಪತಿ",
        "period_sa": "पीठाधिपतिः"
    },
    {
        "id": "d283aaa9-8b32-44c0-8579-55ac6ee0457e",
        "name": "Sri Vishwaprajna Teertha",
        "period": "Peetadhipathi",
        "description": "",
        "image": null,
        "order": 111,
        "is_current": false,
        "is_featured": false,
        "section": "post_madhwa",
        "seq": 11,
        "name_kn": "ಶ್ರೀ ವಿಶ್ವಪ್ರಜ್ಞ ತೀರ್ಥರು",
        "name_sa": "श्री विश्वप्रज्ञतीर्थः",
        "period_kn": "ಪೀಠಾಧಿಪತಿ",
        "period_sa": "पीठाधिपतिः"
    },
    {
        "id": "6abbeb28-52fc-478a-b62d-d5d970defcba",
        "name": "Sri Punyashravana Teertha",
        "period": "Peetadhipathi",
        "description": "",
        "image": null,
        "order": 112,
        "is_current": false,
        "is_featured": false,
        "section": "post_madhwa",
        "seq": 12,
        "name_kn": "ಶ್ರೀ ಪುಣ್ಯಶ್ರವಣ ತೀರ್ಥರು",
        "name_sa": "श्री पुण्यश्रवणतीर्थः",
        "period_kn": "ಪೀಠಾಧಿಪತಿ",
        "period_sa": "पीठाधिपतिः"
    },
    {
        "id": "6a8a602e-acbc-4ec8-9488-6baaa1db6c9c",
        "name": "Sri Vishwottama Teertha",
        "period": "Peetadhipathi",
        "description": "",
        "image": null,
        "order": 113,
        "is_current": false,
        "is_featured": false,
        "section": "post_madhwa",
        "seq": 13,
        "name_kn": "ಶ್ರೀ ವಿಶ್ವೋತ್ತಮ ತೀರ್ಥರು",
        "name_sa": "श्री विश्वोत्तमतीर्थः",
        "period_kn": "ಪೀಠಾಧಿಪತಿ",
        "period_sa": "पीठाधिपतिः"
    },
    {
        "id": "3bdde809-849b-435a-b8de-f2770da3fbab",
        "name": "Sri Vijnanadhisha Teertha",
        "period": "Peetadhipathi",
        "description": "",
        "image": null,
        "order": 114,
        "is_current": false,
        "is_featured": false,
        "section": "post_madhwa",
        "seq": 14,
        "name_kn": "ಶ್ರೀ ವಿಜ್ಞಾನಾಧೀಶ ತೀರ್ಥರು",
        "name_sa": "श्री विज्ञानाधीशतीर्थः",
        "period_kn": "ಪೀಠಾಧಿಪತಿ",
        "period_sa": "पीठाधिपतिः"
    },
    {
        "id": "985de4f8-f972-4dcf-aef4-38d9c9b9dd62",
        "name": "Sri Rajadhiraja Teertha",
        "period": "Peetadhipathi",
        "description": "",
        "image": null,
        "order": 115,
        "is_current": false,
        "is_featured": false,
        "section": "post_madhwa",
        "seq": 15,
        "name_kn": "ಶ್ರೀ ರಾಜಾಧಿರಾಜ ತೀರ್ಥರು",
        "name_sa": "श्री राजाधिराजतीर्थः",
        "period_kn": "ಪೀಠಾಧಿಪತಿ",
        "period_sa": "पीठाधिपतिः"
    },
    {
        "id": "57d66233-c522-4329-acd6-b72e0d302d2f",
        "name": "Sri Raghavendra Teertha",
        "period": "Peetadhipathi",
        "description": "",
        "image": null,
        "order": 116,
        "is_current": false,
        "is_featured": false,
        "section": "post_madhwa",
        "seq": 16,
        "name_kn": "ಶ್ರೀ ರಾಘವೇಂದ್ರ ತೀರ್ಥರು",
        "name_sa": "श्री राघवेन्द्रतीर्थः",
        "period_kn": "ಪೀಠಾಧಿಪತಿ",
        "period_sa": "पीठाधिपतिः"
    },
    {
        "id": "469ec443-7057-440f-b7cc-ea9291b24f12",
        "name": "Sri Gadadhara Teertha",
        "period": "Peetadhipathi",
        "description": "",
        "image": null,
        "order": 117,
        "is_current": false,
        "is_featured": false,
        "section": "post_madhwa",
        "seq": 17,
        "name_kn": "ಶ್ರೀ ಗದಾಧರ ತೀರ್ಥರು",
        "name_sa": "श्री गदाधरतीर्थः",
        "period_kn": "ಪೀಠಾಧಿಪತಿ",
        "period_sa": "पीठाधिपतिः"
    },
    {
        "id": "9a367338-a223-45ec-8a5c-3109079d4e0e",
        "name": "Sri Nidhi Teertha",
        "period": "Peetadhipathi",
        "description": "",
        "image": null,
        "order": 118,
        "is_current": false,
        "is_featured": false,
        "section": "post_madhwa",
        "seq": 18,
        "name_kn": "ಶ್ರೀ ನಿಧಿ ತೀರ್ಥರು",
        "name_sa": "श्री निधितीर्थः",
        "period_kn": "ಪೀಠಾಧಿಪತಿ",
        "period_sa": "पीठाधिपतिः"
    },
    {
        "id": "ce3479db-7bc1-4ec2-b6be-9f75dcd97747",
        "name": "Sri Chakrapani Teertha",
        "period": "Peetadhipathi",
        "description": "",
        "image": null,
        "order": 119,
        "is_current": false,
        "is_featured": false,
        "section": "post_madhwa",
        "seq": 19,
        "name_kn": "ಶ್ರೀ ಚಕ್ರಪಾಣಿ ತೀರ್ಥರು",
        "name_sa": "श्री चक्रपाणितीर्थः",
        "period_kn": "ಪೀಠಾಧಿಪತಿ",
        "period_sa": "पीठाधिपतिः"
    },
    {
        "id": "d3eed4e0-4db0-4658-9c1f-c15c708232cf",
        "name": "Sri Aniruddha Teertha",
        "period": "Peetadhipathi",
        "description": "",
        "image": null,
        "order": 120,
        "is_current": false,
        "is_featured": false,
        "section": "post_madhwa",
        "seq": 20,
        "name_kn": "ಶ್ರೀ ಅನಿರುದ್ಧ ತೀರ್ಥರು",
        "name_sa": "श्री अनिरुद्धतीर्थः",
        "period_kn": "ಪೀಠಾಧಿಪತಿ",
        "period_sa": "पीठाधिपतिः"
    },
    {
        "id": "d599e6cc-e48f-496f-be96-446e864889d6",
        "name": "Sri Pradyumna Teertha",
        "period": "Peetadhipathi",
        "description": "",
        "image": null,
        "order": 121,
        "is_current": false,
        "is_featured": false,
        "section": "post_madhwa",
        "seq": 21,
        "name_kn": "ಶ್ರೀ ಪ್ರದ್ಯುಮ್ನ ತೀರ್ಥರು",
        "name_sa": "श्री प्रद्युम्नतीर्थः",
        "period_kn": "ಪೀಠಾಧಿಪತಿ",
        "period_sa": "पीठाधिपतिः"
    },
    {
        "id": "82bc2a1b-9161-4cd3-a070-85ae765b6d9f",
        "name": "Sri Purandara Teertha",
        "period": "Peetadhipathi",
        "description": "",
        "image": null,
        "order": 122,
        "is_current": false,
        "is_featured": false,
        "section": "post_madhwa",
        "seq": 22,
        "name_kn": "ಶ್ರೀ ಪುರಂದರ ತೀರ್ಥರು",
        "name_sa": "श्री पुरन्दरतीर्थः",
        "period_kn": "ಪೀಠಾಧಿಪತಿ",
        "period_sa": "पीठाधिपतिः"
    },
    {
        "id": "2ec2a108-0a62-4977-b931-2b1b941ad013",
        "name": "Sri Pundarikaksha Teertha",
        "period": "Peetadhipathi",
        "description": "",
        "image": null,
        "order": 123,
        "is_current": false,
        "is_featured": false,
        "section": "post_madhwa",
        "seq": 23,
        "name_kn": "ಶ್ರೀ ಪುಂಡರೀಕಾಕ್ಷ ತೀರ್ಥರು",
        "name_sa": "श्री पुण्डरीकाक्षतीर्थः",
        "period_kn": "ಪೀಠಾಧಿಪತಿ",
        "period_sa": "पीठाधिपतिः"
    },
    {
        "id": "03ef0fee-0330-4206-acfe-676df9df9f0a",
        "name": "Sri Punyashloka Teertha",
        "period": "Peetadhipathi",
        "description": "",
        "image": null,
        "order": 124,
        "is_current": false,
        "is_featured": false,
        "section": "post_madhwa",
        "seq": 24,
        "name_kn": "ಶ್ರೀ ಪುಣ್ಯಶ್ಲೋಕ ತೀರ್ಥರು",
        "name_sa": "श्री पुण्यश्लोकतीर्थः",
        "period_kn": "ಪೀಠಾಧಿಪತಿ",
        "period_sa": "पीठाधिपतिः"
    },
    {
        "id": "90379127-974e-4cff-85be-0f8165240820",
        "name": "Sri Achyuta Teertha",
        "period": "Peetadhipathi",
        "description": "",
        "image": null,
        "order": 125,
        "is_current": false,
        "is_featured": false,
        "section": "post_madhwa",
        "seq": 25,
        "name_kn": "ಶ್ರೀ ಅಚ್ಯುತ ತೀರ್ಥರು",
        "name_sa": "श्री अच्युततीर्थः",
        "period_kn": "ಪೀಠಾಧಿಪತಿ",
        "period_sa": "पीठाधिपतिः"
    },
    {
        "id": "e681fca9-c527-4e7d-a466-65ec22f72660",
        "name": "Sri Damodara Teertha",
        "period": "Peetadhipathi",
        "description": "",
        "image": null,
        "order": 126,
        "is_current": false,
        "is_featured": false,
        "section": "post_madhwa",
        "seq": 26,
        "name_kn": "ಶ್ರೀ ದಾಮೋದರ ತೀರ್ಥರು",
        "name_sa": "श्री दामोदरतीर्थः",
        "period_kn": "ಪೀಠಾಧಿಪತಿ",
        "period_sa": "पीठाधिपतिः"
    },
    {
        "id": "18ecb27f-f082-4891-8a54-1b5aa9c5183d",
        "name": "Sri Raghuvarya Teertha",
        "period": "Peetadhipathi",
        "description": "",
        "image": null,
        "order": 127,
        "is_current": false,
        "is_featured": false,
        "section": "post_madhwa",
        "seq": 27,
        "name_kn": "ಶ್ರೀ ರಘುವರ್ಯ ತೀರ್ಥರು",
        "name_sa": "श्री रघुवर्यतीर्थः",
        "period_kn": "ಪೀಠಾಧಿಪತಿ",
        "period_sa": "पीठाधिपतिः"
    },
    {
        "id": "304ed025-f93c-44b5-a805-2e6b3919ac78",
        "name": "Sri Trivikrama Teertha",
        "period": "Peetadhipathi",
        "description": "",
        "image": null,
        "order": 128,
        "is_current": false,
        "is_featured": false,
        "section": "post_madhwa",
        "seq": 28,
        "name_kn": "ಶ್ರೀ ತ್ರಿವಿಕ್ರಮ ತೀರ್ಥರು",
        "name_sa": "श्री त्रिविक्रमतीर्थः",
        "period_kn": "ಪೀಠಾಧಿಪತಿ",
        "period_sa": "पीठाधिपतिः"
    },
    {
        "id": "bd8d75ad-80d6-484c-9095-a99fcaad6dbb",
        "name": "Sri Raghupati Teertha",
        "period": "Peetadhipathi",
        "description": "",
        "image": null,
        "order": 129,
        "is_current": false,
        "is_featured": false,
        "section": "post_madhwa",
        "seq": 29,
        "name_kn": "ಶ್ರೀ ರಘುಪತಿ ತೀರ್ಥರು",
        "name_sa": "श्री रघुपतितीर्थः",
        "period_kn": "ಪೀಠಾಧಿಪತಿ",
        "period_sa": "पीठाधिपतिः"
    },
    {
        "id": "a046cf21-9218-4e9f-884e-b1bab30487ee",
        "name": "Sri Raghuvallabha Teertha",
        "period": "Peetadhipathi",
        "description": "",
        "image": null,
        "order": 130,
        "is_current": false,
        "is_featured": false,
        "section": "post_madhwa",
        "seq": 30,
        "name_kn": "ಶ್ರೀ ರಘುವಲ್ಲಭ ತೀರ್ಥರು",
        "name_sa": "श्री रघुवल्लभतीर्थः",
        "period_kn": "ಪೀಠಾಧಿಪತಿ",
        "period_sa": "पीठाधिपतिः"
    },
    {
        "id": "1584ead9-b879-4875-8f2b-d2bc5916940b",
        "name": "Sri Vedagarbha Teertha",
        "period": "Peetadhipathi",
        "description": "",
        "image": null,
        "order": 131,
        "is_current": false,
        "is_featured": false,
        "section": "post_madhwa",
        "seq": 31,
        "name_kn": "ಶ್ರೀ ವೇದಗರ್ಭ ತೀರ್ಥರು",
        "name_sa": "श्री वेदगर्भतीर्थः",
        "period_kn": "ಪೀಠಾಧಿಪತಿ",
        "period_sa": "पीठाधिपतिः"
    },
    {
        "id": "82f4207c-22a3-438e-9b3c-26fd398cf429",
        "name": "Sri Raghupungava Teertha",
        "period": "Peetadhipathi",
        "description": "",
        "image": null,
        "order": 132,
        "is_current": false,
        "is_featured": false,
        "section": "post_madhwa",
        "seq": 32,
        "name_kn": "ಶ್ರೀ ರಘುಪುಂಗವ ತೀರ್ಥರು",
        "name_sa": "श्री रघुपुङ्गवतीर्थः",
        "period_kn": "ಪೀಠಾಧಿಪತಿ",
        "period_sa": "पीठाधिपतिः"
    },
    {
        "id": "9427dbfd-7599-4738-a53a-3b75c80bdc72",
        "name": "Sri Ramachandra Teertha",
        "period": "Peetadhipathi",
        "description": "",
        "image": null,
        "order": 133,
        "is_current": false,
        "is_featured": false,
        "section": "post_madhwa",
        "seq": 33,
        "name_kn": "ಶ್ರೀ ರಾಮಚಂದ್ರ ತೀರ್ಥರು",
        "name_sa": "श्री रामचन्द्रतीर्थः",
        "period_kn": "ಪೀಠಾಧಿಪತಿ",
        "period_sa": "पीठाधिपतिः"
    },
    {
        "id": "48dfb456-aa37-4c1f-bce3-0d8b1e369161",
        "name": "Sri Raghavendra Teertha",
        "period": "Peetadhipathi",
        "description": "",
        "image": null,
        "order": 134,
        "is_current": false,
        "is_featured": false,
        "section": "post_madhwa",
        "seq": 34,
        "name_kn": "ಶ್ರೀ ರಾಘವೇಂದ್ರ ತೀರ್ಥರು",
        "name_sa": "श्री राघवेन्द्रतीर्थः",
        "period_kn": "ಪೀಠಾಧಿಪತಿ",
        "period_sa": "पीठाधिपतिः"
    },
    {
        "id": "9af8cd84-c0cd-471a-b8f9-bf8c96871b48",
        "name": "Sri Raghuara (Raghuraja) Teertha",
        "period": "Peetadhipathi",
        "description": "",
        "image": null,
        "order": 135,
        "is_current": false,
        "is_featured": false,
        "section": "post_madhwa",
        "seq": 35,
        "name_kn": "ಶ್ರೀ ರಘುವರ (ರಘುರಾಜ) ತೀರ್ಥರು",
        "name_sa": "श्री रघुवर(रघुराज)तीर्थः",
        "period_kn": "ಪೀಠಾಧಿಪತಿ",
        "period_sa": "पीठाधिपतिः"
    },
    {
        "id": "43e88021-71ad-4c86-86da-48b81c5475c9",
        "name": "Sri Raghuttama Teertha",
        "period": "Peetadhipathi",
        "description": "",
        "image": null,
        "order": 201,
        "is_current": false,
        "is_featured": false,
        "section": "bhimanakatte",
        "seq": 36,
        "name_kn": "ಶ್ರೀ ರಘೂತ್ತಮ ತೀರ್ಥರು",
        "name_sa": "श्री रघूत्तमतीर्थः",
        "period_kn": "ಪೀಠಾಧಿಪತಿ",
        "period_sa": "पीठाधिपतिः"
    },
    {
        "id": "71bde9bf-3424-4c43-808a-8138be44c593",
        "name": "Sri Raghuvarya Teertha",
        "period": "Peetadhipathi",
        "description": "",
        "image": null,
        "order": 202,
        "is_current": false,
        "is_featured": false,
        "section": "bhimanakatte",
        "seq": 37,
        "name_kn": "ಶ್ರೀ ರಘುವರ್ಯ ತೀರ್ಥರು",
        "name_sa": "श्री रघुवर्यतीर्थः",
        "period_kn": "ಪೀಠಾಧಿಪತಿ",
        "period_sa": "पीठाधिपतिः"
    },
    {
        "id": "2b4b6342-dda1-4f7b-b7f8-d675dfe59656",
        "name": "Sri Raghupriya Teertha",
        "period": "Peetadhipathi",
        "description": "",
        "image": null,
        "order": 203,
        "is_current": false,
        "is_featured": false,
        "section": "bhimanakatte",
        "seq": 38,
        "name_kn": "ಶ್ರೀ ರಘುಪ್ರಿಯ ತೀರ್ಥರು",
        "name_sa": "श्री रघुप्रियतीर्थः",
        "period_kn": "ಪೀಠಾಧಿಪತಿ",
        "period_sa": "पीठाधिपतिः"
    },
    {
        "id": "8d164abb-5fdc-41d8-99bf-d101f87aa4bc",
        "name": "Sri Raghunatha Teertha",
        "period": "Peetadhipathi",
        "description": "",
        "image": null,
        "order": 204,
        "is_current": false,
        "is_featured": false,
        "section": "bhimanakatte",
        "seq": 39,
        "name_kn": "ಶ್ರೀ ರಘುನಾಥ ತೀರ್ಥರು",
        "name_sa": "श्री रघुनाथतीर्थः",
        "period_kn": "ಪೀಠಾಧಿಪತಿ",
        "period_sa": "पीठाधिपतिः"
    },
    {
        "id": "a1b150a9-cfaa-4985-960b-6e365f280249",
        "name": "Sri Raghupraveera & Sri Raghudhvaja Teertha",
        "period": "Peetadhipathi",
        "description": "",
        "image": null,
        "order": 205,
        "is_current": false,
        "is_featured": false,
        "section": "bhimanakatte",
        "seq": 40,
        "name_kn": "ಶ್ರೀ ರಘುಪ್ರವೀರ ಮತ್ತು ಶ್ರೀ ರಘುಧ್ವಜ ತೀರ್ಥರು",
        "name_sa": "श्री रघुप्रवीरः श्री रघुध्वजतीर्थश्च",
        "period_kn": "ಪೀಠಾಧಿಪತಿ",
        "period_sa": "पीठाधिपतिः"
    },
    {
        "id": "68ae4210-ca55-4b38-872c-445587a508a1",
        "name": "Sri Raghubhushana Teertha",
        "period": "Peetadhipathi",
        "description": "",
        "image": null,
        "order": 206,
        "is_current": false,
        "is_featured": false,
        "section": "bhimanakatte",
        "seq": 41,
        "name_kn": "ಶ್ರೀ ರಘುಭೂಷಣ ತೀರ್ಥರು",
        "name_sa": "श्री रघुभूषणतीर्थः",
        "period_kn": "ಪೀಠಾಧಿಪತಿ",
        "period_sa": "पीठाधिपतिः"
    },
    {
        "id": "6ac18280-30e6-4719-bfbe-c3165aa13c9c",
        "name": "Sri Raghutilaka Teertha",
        "period": "Peetadhipathi",
        "description": "",
        "image": null,
        "order": 207,
        "is_current": false,
        "is_featured": false,
        "section": "bhimanakatte",
        "seq": 42,
        "name_kn": "ಶ್ರೀ ರಘುತಿಲಕ ತೀರ್ಥರು",
        "name_sa": "श्री रघुतिलकतीर्थः",
        "period_kn": "ಪೀಠಾಧಿಪತಿ",
        "period_sa": "पीठाधिपतिः"
    },
    {
        "id": "a576eb8c-21a5-456a-aa5d-6f2b64f4ad25",
        "name": "Sri Raghumanya Teertha",
        "period": "Immediate Previous Pontiff",
        "description": "The beloved immediate previous pontiff whose grace, simplicity and devotion continue to inspire the devotees. His aradhana is observed with vedic honors.",
        "image": "/assets/zpfmzbxt_ShriRaghumanyaTeertharu.png",
        "order": 208,
        "is_current": false,
        "is_featured": true,
        "section": "bhimanakatte",
        "seq": 43,
        "name_kn": "ಶ್ರೀ ರಘುಮಾನ್ಯ ತೀರ್ಥರು",
        "name_sa": "श्री रघुमान्यतीर्थः",
        "period_kn": "ಹಿಂದಿನ ಪೀಠಾಧಿಪತಿಗಳು",
        "period_sa": "पूर्वपीठाधिपतिः",
        "description_kn": "ಭಕ್ತರನ್ನು ಇಂದಿಗೂ ಪ್ರೇರೇಪಿಸುತ್ತಿರುವ ಅನುಗ್ರಹ, ಸರಳತೆ ಮತ್ತು ಭಕ್ತಿಯ ಮೂರ್ತಿ — ಪ್ರೀತಿಪಾತ್ರ ಹಿಂದಿನ ಪೀಠಾಧಿಪತಿಗಳು. ಅವರ ಆರಾಧನೆ ವೈದಿಕ ಗೌರವಗಳೊಂದಿಗೆ ನಡೆಯುತ್ತದೆ.",
        "description_sa": "यस्य अनुग्रहः सरलता भक्तिश्च अद्यापि भक्तान् प्रेरयन्ति सः प्रियः पूर्वपीठाधिपतिः। तस्य आराधना वैदिकसम्मानैः क्रियते।"
    },
    {
        "id": "260ff5b7-14ad-4c6e-a4b9-786a3e4f1390",
        "name": "Sri 1008 Sri Raghuvarendra Teertha Swamiji",
        "period": "Present Peetadhipathi",
        "description": "The present Peetadhipathi of Sri Bhimasethu Munivrunda Mutt (Bhimanakatte Matha). A scholar who places utmost importance on traditional values and sagic disciplines, he actively initiates the development of the Mutt and voluntarily performs Japa, Tapa, and the worship of icons continuously revered since the beginning of the Sanyasa Parampara.",
        "image": "/assets/verlre7m_ShriRaghuvarendraTeertharu.jpeg",
        "order": 209,
        "is_current": true,
        "is_featured": true,
        "section": "bhimanakatte",
        "seq": 44,
        "name_kn": "ಶ್ರೀ ೧೦೦೮ ಶ್ರೀ ರಘುವರೇಂದ್ರ ತೀರ್ಥ ಸ್ವಾಮೀಜಿ",
        "name_sa": "श्री १००८ श्री रघुवरेन्द्रतीर्थस्वामिनः",
        "period_kn": "ಪ್ರಸ್ತುತ ಪೀಠಾಧಿಪತಿಗಳು",
        "period_sa": "वर्तमानपीठाधिपतिः",
        "description_kn": "ಶ್ರೀ ಭೀಮಸೇತು ಮುನಿವೃಂದ ಮಠದ (ಭೀಮನಕಟ್ಟೆ ಮಠ) ಪ್ರಸ್ತುತ ಪೀಠಾಧಿಪತಿಗಳು. ಸಾಂಪ್ರದಾಯಿಕ ಮೌಲ್ಯಗಳಿಗೆ ಮತ್ತು ಋಷಿ ಶಿಸ್ತುಗಳಿಗೆ ಪರಮ ಪ್ರಾಧಾನ್ಯ ನೀಡುವ ವಿದ್ವಾಂಸರು; ಮಠದ ಅಭಿವೃದ್ಧಿಯನ್ನು ಮುನ್ನಡೆಸುತ್ತಾ, ಸಂನ್ಯಾಸ ಪರಂಪರೆಯ ಆರಂಭದಿಂದ ಪೂಜಿಸಲ್ಪಡುತ್ತಿರುವ ವಿಗ್ರಹಗಳ ಜಪ, ತಪ ಮತ್ತು ಪೂಜೆಯನ್ನು ನಿತ್ಯ ನೆರವೇರಿಸುತ್ತಿದ್ದಾರೆ.",
        "description_sa": "श्री भीमसेतुमुनिवृन्दमठस्य (भीमनकट्टेमठस्य) वर्तमानपीठाधिपतिः। पारम्परिकमूल्येषु ऋषिनियमेषु च परमप्राधान्यं ददत् विद्वान्; मठविकासं प्रवर्तयन् संन्यासपरम्परारम्भात् पूजितानां विग्रहाणां जपं तपः पूजां च नित्यं करोति।"
    }
];

export const sancharaSchedule = [
    {
        "id": "ec58ebe9-cf4f-4c4b-8c25-dde5664b1a32",
        "date": "2026-01-15",
        "location": "Bengaluru — Sri Raghavendra Swami Mutt, Doddabommasandra",
        "description": "Sanchara at the Bengaluru branch — Vishnu Sahasranama parayana and pravachana for devotees.",
        "image": "/assets/zh6ml123_current_pontiff.jpeg",
        "order": 1,
        "description_kn": "ಬೆಂಗಳೂರು ಶಾಖೆಯಲ್ಲಿ ಸಂಚಾರ — ಭಕ್ತರಿಗೆ ವಿಷ್ಣು ಸಹಸ್ರನಾಮ ಪಾರಾಯಣ ಮತ್ತು ಪ್ರವಚನ.",
        "description_sa": "बेङ्गळूरुशाखायां सञ्चारः — भक्तेभ्यः विष्णुसहस्रनामपारायणं प्रवचनं च।",
        "location_kn": "ಬೆಂಗಳೂರು — ಶ್ರೀ ರಾಘವೇಂದ್ರ ಸ್ವಾಮಿ ಮಠ, ದೊಡ್ಡಬೊಮ್ಮಸಂದ್ರ",
        "location_sa": "बेङ्गळूरु — श्री राघवेन्द्रस्वामिमठः, दोड्डबोम्मसन्द्र"
    },
    {
        "id": "ff2699c2-4e2c-4f6c-a6fc-01a1fb603ef9",
        "date": "2026-02-05",
        "location": "Udupi — Car Street",
        "description": "Darshan and pravachana in the ancient temple city of Udupi.",
        "image": "/assets/ev8zy4nx_1.jpeg",
        "order": 2,
        "description_kn": "ಪ್ರಾಚೀನ ದೇವಾಲಯ ನಗರಿ ಉಡುಪಿಯಲ್ಲಿ ದರ್ಶನ ಮತ್ತು ಪ್ರವಚನ.",
        "description_sa": "प्राचीनदेवालयनगर्याम् उडुप्यां दर्शनं प्रवचनं च।",
        "location_kn": "ಉಡುಪಿ — ಕಾರ್ ಸ್ಟ್ರೀಟ್",
        "location_sa": "उडुपी — रथवीथी"
    },
    {
        "id": "b6754d47-36c8-43e8-a018-3f2ccc1e4236",
        "date": "2026-02-20",
        "location": "Sathyamangalam — Sri Raghudwaja Vrundavana Sannidhi",
        "description": "Aradhana at the vrundavana of Sri Raghudwaja Teertharu in Tamil Nadu.",
        "image": "/assets/7a5qi4sr_3.jpg",
        "order": 3,
        "description_kn": "ತಮಿಳುನಾಡಿನಲ್ಲಿ ಶ್ರೀ ರಘುಧ್ವಜ ತೀರ್ಥರ ವೃಂದಾವನದಲ್ಲಿ ಆರಾಧನೆ.",
        "description_sa": "तमिळ्नाडुराज्ये श्री रघुध्वजतीर्थस्य वृन्दावने आराधनम्।",
        "location_kn": "ಸತ್ಯಮಂಗಲಂ — ಶ್ರೀ ರಘುಧ್ವಜ ವೃಂದಾವನ ಸನ್ನಿಧಿ",
        "location_sa": "सत्यमङ्गलम् — श्री रघुध्वजवृन्दावनसन्निधिः"
    },
    {
        "id": "3963d846-e72a-46e8-8399-d7b87c2ac4c7",
        "date": "2026-03-10",
        "location": "Mysuru — Devotees' Sabha",
        "description": "Devotee assembly with anugraha bhashana, Bhagavata parayana and prasada bhojana.",
        "image": "/assets/ehmgnazo_diety1.jpg",
        "order": 4,
        "description_kn": "ಅನುಗ್ರಹ ಭಾಷಣ, ಭಾಗವತ ಪಾರಾಯಣ ಮತ್ತು ಪ್ರಸಾದ ಭೋಜನದೊಂದಿಗೆ ಭಕ್ತರ ಸಮಾವೇಶ.",
        "description_sa": "अनुग्रहभाषणेन भागवतपारायणेन प्रसादभोजनेन च भक्तसमावेशः।",
        "location_kn": "ಮೈಸೂರು — ಭಕ್ತರ ಸಭೆ",
        "location_sa": "मैसूरु — भक्तसभा"
    },
    {
        "id": "434e172a-ec3a-473f-986c-112b53c0560c",
        "date": "2026-04-08",
        "location": "Shivamogga — District Sanchara",
        "description": "Blessings to devotees across Shivamogga district ahead of Sri Rama Navami.",
        "image": "/assets/n0mtazl3_diety3.jpeg",
        "order": 5,
        "description_kn": "ಶ್ರೀ ರಾಮ ನವಮಿಗೆ ಮುನ್ನ ಶಿವಮೊಗ್ಗ ಜಿಲ್ಲೆಯ ಭಕ್ತರಿಗೆ ಆಶೀರ್ವಾದ.",
        "description_sa": "श्रीरामनवम्याः प्राक् शिवमोग्गामण्डलस्य भक्तेभ्यः आशीर्वादः।",
        "location_kn": "ಶಿವಮೊಗ್ಗ — ಜಿಲ್ಲಾ ಸಂಚಾರ",
        "location_sa": "शिवमोग्गा — मण्डलसञ्चारः"
    }
];

export const branchLocations = [
  {
    id: "bdc9c339-04cd-40f7-afef-4a3f7c096e46",
    name: "Sri Bhimasethu Munivrunda Matha (Moola Matha)",
    address: "Bhimanakatte, Doorvasapuram Post, Thirthahalli",
    city: "Thirthahalli",
    state: "Karnataka",
    pincode: "577448",
    country: "India",
    phone: "+91 83348 27523",
    latitude: 13.6842,
    longitude: 75.2454,
  },
  {
    id: "2ac69442-6116-4b0b-9103-af6409b8b5f3",
    name: "Sri Bhimanakatte Matha — Udupi",
    address: "Car Street, Udupi",
    city: "Udupi",
    state: "Karnataka",
    pincode: "576101",
    country: "India",
    phone: null,
    latitude: 13.3409,
    longitude: 74.7421,
  },
  {
    id: "24987a7a-2324-419f-a519-467ccdcc7ed9",
    name: "Sri Raghavendra Swami Mutt — Bengaluru",
    address: "Howthinarayanappa Garden, Chamundeswari Layout, Doddabommasandra",
    city: "Bengaluru",
    state: "Karnataka",
    pincode: "560097",
    country: "India",
    phone: null,
    latitude: 13.0827,
    longitude: 77.5877,
  },
  {
    id: "34738c3c-1cdd-4a4a-92cd-a3fe1a1e497c",
    name: "Sri Raghudwaja Vrundavana Sannidhi",
    address: "Agrahara, Sathyamangalam",
    city: "Sathyamangalam",
    state: "Tamil Nadu",
    pincode: "638401",
    country: "India",
    phone: null,
    latitude: 11.5054,
    longitude: 77.2378,
  },
];

export const dailyEvents = [
    {
        "id": "dc63ba00-cbe4-495a-a7ca-cd547568d3ac",
        "time": "05:30 AM",
        "name": "Suprabhata",
        "description": "Awakening of the deities with vedic hymns.",
        "period": "morning",
        "order": 1,
        "description_kn": "ವೈದಿಕ ಸ್ತೋತ್ರಗಳೊಂದಿಗೆ ದೇವರ ಜಾಗರಣೆ.",
        "description_sa": "वैदिकस्तोत्रैः देवानां प्रबोधनम्।",
        "name_kn": "ಸುಪ್ರಭಾತ",
        "name_sa": "सुप्रभातम्"
    },
    {
        "id": "147f94e1-5cb8-46e5-aa9d-a8f10f2f71ab",
        "time": "06:00 AM",
        "name": "Abhisheka",
        "description": "Sacred bathing of the deities with panchamrutha.",
        "period": "morning",
        "order": 2,
        "description_kn": "ಪಂಚಾಮೃತದಿಂದ ದೇವರ ಪವಿತ್ರ ಸ್ನಾನ.",
        "description_sa": "पञ्चामृतेन देवानां पवित्रस्नानम्।",
        "name_kn": "ಅಭಿಷೇಕ",
        "name_sa": "अभिषेकः"
    },
    {
        "id": "b5cebcc9-8026-4713-92a9-54486c0f6a9f",
        "time": "07:30 AM",
        "name": "Alankara & Naivedya",
        "description": "Adornment of the deities and offering of naivedya.",
        "period": "morning",
        "order": 3,
        "description_kn": "ದೇವರ ಅಲಂಕಾರ ಮತ್ತು ನೈವೇದ್ಯ ಸಮರ್ಪಣೆ.",
        "description_sa": "देवानाम् अलङ्कारः नैवेद्यसमर्पणं च।",
        "name_kn": "ಅಲಂಕಾರ ಮತ್ತು ನೈವೇದ್ಯ",
        "name_sa": "अलङ्कारः नैवेद्यं च"
    },
    {
        "id": "aab9a6e4-5a8c-418a-a8bd-7c808bae0716",
        "time": "08:30 AM",
        "name": "Mangalarati",
        "description": "Morning arati and darshana for devotees.",
        "period": "morning",
        "order": 4,
        "description_kn": "ಬೆಳಗಿನ ಆರತಿ ಮತ್ತು ಭಕ್ತರಿಗೆ ದರ್ಶನ.",
        "description_sa": "प्रातःकालारतिः भक्तेभ्यः दर्शनं च।",
        "name_kn": "ಮಂಗಳಾರತಿ",
        "name_sa": "मङ्गलारतिः"
    },
    {
        "id": "7e7e9dcc-7122-4815-8783-02dca57813e9",
        "time": "12:00 PM",
        "name": "Madhyahna Pooja",
        "description": "Midday worship and mahapooja.",
        "period": "morning",
        "order": 5,
        "description_kn": "ಮಧ್ಯಾಹ್ನದ ಪೂಜೆ ಮತ್ತು ಮಹಾಪೂಜೆ.",
        "description_sa": "मध्याह्नपूजा महापूजा च।",
        "name_kn": "ಮಧ್ಯಾಹ್ನ ಪೂಜೆ",
        "name_sa": "मध्याह्नपूजा"
    },
    {
        "id": "ba7f143b-1d89-4005-aa30-df2803e9dc7f",
        "time": "12:30 PM",
        "name": "Annadana",
        "description": "Prasada bhojana served to all devotees.",
        "period": "morning",
        "order": 6,
        "description_kn": "ಎಲ್ಲಾ ಭಕ್ತರಿಗೆ ಪ್ರಸಾದ ಭೋಜನ.",
        "description_sa": "सर्वेभ्यः भक्तेभ्यः प्रसादभोजनम्।",
        "name_kn": "ಅನ್ನದಾನ",
        "name_sa": "अन्नदानम्"
    },
    {
        "id": "c1e356a4-a469-4e26-bce3-81a4e3cc29ef",
        "time": "05:30 PM",
        "name": "Sandhya Pooja",
        "description": "Evening worship at the sannidhi.",
        "period": "evening",
        "order": 7,
        "description_kn": "ಸನ್ನಿಧಿಯಲ್ಲಿ ಸಂಜೆಯ ಪೂಜೆ.",
        "description_sa": "सन्निधौ सायङ्कालपूजा।",
        "name_kn": "ಸಂಧ್ಯಾ ಪೂಜೆ",
        "name_sa": "सन्ध्यापूजा"
    },
    {
        "id": "95072918-254d-46e5-9a26-d860d02dc4e0",
        "time": "06:30 PM",
        "name": "Pravachana / Bhajana",
        "description": "Discourses on shastra and devotional singing.",
        "period": "evening",
        "order": 8,
        "description_kn": "ಶಾಸ್ತ್ರ ಪ್ರವಚನ ಮತ್ತು ಭಕ್ತಿಗೀತೆಗಳು.",
        "description_sa": "शास्त्रप्रवचनं भक्तिगीतानि च।",
        "name_kn": "ಪ್ರವಚನ / ಭಜನೆ",
        "name_sa": "प्रवचनम् / भजनम्"
    },
    {
        "id": "d6f490a8-0b05-44e5-b871-3db60bda1930",
        "time": "07:30 PM",
        "name": "Ratri Naivedya",
        "description": "Night naivedya to the deities.",
        "period": "evening",
        "order": 9,
        "description_kn": "ದೇವರಿಗೆ ರಾತ್ರಿಯ ನೈವೇದ್ಯ.",
        "description_sa": "देवेभ्यः रात्रौ नैवेद्यम्।",
        "name_kn": "ರಾತ್ರಿ ನೈವೇದ್ಯ",
        "name_sa": "रात्रिनैवेद्यम्"
    },
    {
        "id": "f6924ba0-7a39-4a86-83de-e858b054a67e",
        "time": "08:15 PM",
        "name": "Shayanotsava",
        "description": "The deities are ceremonially laid to rest for the night.",
        "period": "evening",
        "order": 10,
        "description_kn": "ದೇವರನ್ನು ರಾತ್ರಿಗೆ ವಿಧಿವತ್ತಾಗಿ ಶಯನಗೊಳಿಸಲಾಗುತ್ತದೆ.",
        "description_sa": "देवाः रात्रौ विधिवत् शयनं कार्यन्ते।",
        "name_kn": "ಶಯನೋತ್ಸವ",
        "name_sa": "शयनोत्सवः"
    }
];

export const sevasList = [
    {
        "id": "24fc0755-f98e-43ca-802a-d477055e7fa8",
        "name": "Nitya Pooja Seva",
        "amount": 251,
        "description": "Sponsor the daily worship of Sri Moola Rama Devaru at the Matha in your name and gotra.",
        "category": "Daily",
        "image": null,
        "order": 0,
        "description_kn": "ನಿಮ್ಮ ಹೆಸರು ಮತ್ತು ಗೋತ್ರದಲ್ಲಿ ಶ್ರೀ ಮೂಲರಾಮ ದೇವರ ನಿತ್ಯ ಪೂಜೆಯ ಪ್ರಾಯೋಜಕತ್ವ.",
        "description_sa": "भवतां नाम्ना गोत्रेण च श्रीमूलरामदेवस्य नित्यपूजायाः प्रायोजनम्।",
        "name_kn": "ನಿತ್ಯ ಪೂಜಾ ಸೇವೆ",
        "name_sa": "नित्यपूजासेवा",
        "category_kn": "ನಿತ್ಯ",
        "category_sa": "नित्यम्"
    },
    {
        "id": "4de6d11b-a885-47d5-be59-af8a29d601d3",
        "name": "Panchamrutha Abhisheka",
        "amount": 501,
        "description": "Sacred bathing of the deities with milk, curd, honey, ghee and sugar followed by mangalarati.",
        "category": "Abhisheka",
        "image": null,
        "order": 0,
        "description_kn": "ಹಾಲು, ಮೊಸರು, ಜೇನು, ತುಪ್ಪ ಮತ್ತು ಸಕ್ಕರೆಯಿಂದ ದೇವರ ಪವಿತ್ರ ಅಭಿಷೇಕ, ನಂತರ ಮಂಗಳಾರತಿ.",
        "description_sa": "क्षीरदधिमधुघृतशर्कराभिः देवानां पवित्राभिषेकः, ततः मङ्गलारतिः।",
        "name_kn": "ಪಂಚಾಮೃತ ಅಭಿಷೇಕ",
        "name_sa": "पञ्चामृताभिषेकः",
        "category_kn": "ಅಭಿಷೇಕ",
        "category_sa": "अभिषेकः"
    },
    {
        "id": "16a70060-81bc-4e6b-bd2c-fc7406ef3a64",
        "name": "Rudrabhisheka",
        "amount": 751,
        "description": "Abhisheka to Sri Rudra with Namaka-Chamaka parayana for peace, health and prosperity.",
        "category": "Abhisheka",
        "image": null,
        "order": 0,
        "description_kn": "ಶಾಂತಿ, ಆರೋಗ್ಯ ಮತ್ತು ಸಮೃದ್ಧಿಗಾಗಿ ನಮಕ-ಚಮಕ ಪಾರಾಯಣದೊಂದಿಗೆ ಶ್ರೀ ರುದ್ರನಿಗೆ ಅಭಿಷೇಕ.",
        "description_sa": "शान्त्यारोग्यसमृद्ध्यर्थं नमकचमकपारायणेन श्रीरुद्राभिषेकः।",
        "name_kn": "ರುದ್ರಾಭಿಷೇಕ",
        "name_sa": "रुद्राभिषेकः",
        "category_kn": "ಅಭಿಷೇಕ",
        "category_sa": "अभिषेकः"
    },
    {
        "id": "a032bfa5-c727-4fb9-b24c-801228a8d2be",
        "name": "Sri Satyanarayana Pooja",
        "amount": 1101,
        "description": "Traditional Sri Satyanarayana Vrata Pooja for family well-being and auspicious beginnings.",
        "category": "Pooja",
        "image": null,
        "order": 0,
        "description_kn": "ಕುಟುಂಬದ ಕ್ಷೇಮ ಮತ್ತು ಶುಭಾರಂಭಗಳಿಗಾಗಿ ಸಾಂಪ್ರದಾಯಿಕ ಶ್ರೀ ಸತ್ಯನಾರಾಯಣ ವ್ರತ ಪೂಜೆ.",
        "description_sa": "कुटुम्बक्षेमाय शुभारम्भाय च पारम्परिकं श्रीसत्यनारायणव्रतपूजनम्।",
        "name_kn": "ಶ್ರೀ ಸತ್ಯನಾರಾಯಣ ಪೂಜೆ",
        "name_sa": "श्री सत्यनारायणपूजा",
        "category_kn": "ಪೂಜೆ",
        "category_sa": "पूजा"
    },
    {
        "id": "7c2ce3d3-439d-4b23-a703-36ef533f46e7",
        "name": "Vishnu Sahasranama Parayana",
        "amount": 351,
        "description": "Recitation of the thousand names of Sri Maha Vishnu in your sankalpa.",
        "category": "Parayana",
        "image": null,
        "order": 0,
        "description_kn": "ನಿಮ್ಮ ಸಂಕಲ್ಪದಲ್ಲಿ ಶ್ರೀ ಮಹಾವಿಷ್ಣುವಿನ ಸಹಸ್ರನಾಮಗಳ ಪಠಣ.",
        "description_sa": "भवतां सङ्कल्पे श्रीमहाविष्णोः सहस्रनाम्नां पठनम्।",
        "name_kn": "ವಿಷ್ಣು ಸಹಸ್ರನಾಮ ಪಾರಾಯಣ",
        "name_sa": "विष्णुसहस्रनामपारायणम्",
        "category_kn": "ಪಾರಾಯಣ",
        "category_sa": "पारायणम्"
    },
    {
        "id": "a6ecdc62-28d7-4a01-b2f4-f63a198ed58b",
        "name": "Annadana Seva",
        "amount": 2501,
        "description": "Sponsor prasada bhojana for devotees visiting the Matha — the noblest of danas.",
        "category": "Annadana",
        "image": null,
        "order": 0,
        "description_kn": "ಮಠಕ್ಕೆ ಬರುವ ಭಕ್ತರಿಗೆ ಪ್ರಸಾದ ಭೋಜನದ ಪ್ರಾಯೋಜಕತ್ವ — ದಾನಗಳಲ್ಲಿ ಶ್ರೇಷ್ಠವಾದದ್ದು.",
        "description_sa": "मठम् आगच्छतां भक्तानां प्रसादभोजनस्य प्रायोजनम् — दानेषु श्रेष्ठम्।",
        "name_kn": "ಅನ್ನದಾನ ಸೇವೆ",
        "name_sa": "अन्नदानसेवा",
        "category_kn": "ಅನ್ನದಾನ",
        "category_sa": "अन्नदानम्"
    },
    {
        "id": "008e8efd-53e2-4d93-b74f-f22f4eb40ab1",
        "name": "Go Seva",
        "amount": 501,
        "description": "Contribute to the feeding and care of the sacred cows at the Matha Go Shala.",
        "category": "Go Shala",
        "image": null,
        "order": 0,
        "description_kn": "ಮಠದ ಗೋಶಾಲೆಯ ಪವಿತ್ರ ಗೋವುಗಳ ಆಹಾರ ಮತ್ತು ಆರೈಕೆಗೆ ಕೊಡುಗೆ.",
        "description_sa": "मठगोशालायाः पवित्रगवां पोषणाय परिचर्यायै च योगदानम्।",
        "name_kn": "ಗೋ ಸೇವೆ",
        "name_sa": "गोसेवा",
        "category_kn": "ಗೋಶಾಲೆ",
        "category_sa": "गोशाला"
    },
    {
        "id": "04bd55c6-6873-4218-8797-ded4741b027c",
        "name": "Aaradhana Mahotsava Seva",
        "amount": 5001,
        "description": "Participate in the annual aradhana mahotsava of the pontiffs with a full-day sponsorship.",
        "category": "Utsava",
        "image": null,
        "order": 0,
        "description_kn": "ಪೀಠಾಧಿಪತಿಗಳ ವಾರ್ಷಿಕ ಆರಾಧನಾ ಮಹೋತ್ಸವದಲ್ಲಿ ಪೂರ್ಣದಿನದ ಪ್ರಾಯೋಜಕತ್ವದೊಂದಿಗೆ ಭಾಗವಹಿಸಿ.",
        "description_sa": "पीठाधिपतीनां वार्षिकाराधनामहोत्सवे पूर्णदिनप्रायोजनेन भागग्रहणम्।",
        "name_kn": "ಆರಾಧನಾ ಮಹೋತ್ಸವ ಸೇವೆ",
        "name_sa": "आराधनामहोत्सवसेवा",
        "category_kn": "ಉತ್ಸವ",
        "category_sa": "उत्सवः"
    },
    {
        "id": "a7d589de-d3c6-4996-83d7-313ab5314dc5",
        "name": "Vahana Pooja",
        "amount": 251,
        "description": "Blessing pooja for your new or existing vehicle by the Matha priests.",
        "category": "Pooja",
        "image": null,
        "order": 0,
        "description_kn": "ಮಠದ ಅರ್ಚಕರಿಂದ ನಿಮ್ಮ ಹೊಸ ಅಥವಾ ಈಗಿರುವ ವಾಹನಕ್ಕೆ ಆಶೀರ್ವಾದ ಪೂಜೆ.",
        "description_sa": "मठार्चकैः भवतां नूतनस्य विद्यमानस्य वा वाहनस्य आशीर्वादपूजा।",
        "name_kn": "ವಾಹನ ಪೂಜೆ",
        "name_sa": "वाहनपूजा",
        "category_kn": "ಪೂಜೆ",
        "category_sa": "पूजा"
    },
    {
        "id": "07de688b-8e70-4a97-a52d-4d030fd96e9d",
        "name": "Nama Karana",
        "amount": 1101,
        "description": "Naming ceremony for the newborn conducted per shastra in the sannidhi of the deities.",
        "category": "Samskara",
        "image": null,
        "order": 0,
        "description_kn": "ದೇವರ ಸನ್ನಿಧಿಯಲ್ಲಿ ಶಾಸ್ತ್ರೋಕ್ತವಾಗಿ ನವಜಾತ ಶಿಶುವಿನ ನಾಮಕರಣ ಸಂಸ್ಕಾರ.",
        "description_sa": "देवसन्निधौ शास्त्रोक्तरीत्या नवजातशिशोः नामकरणसंस्कारः।",
        "name_kn": "ನಾಮಕರಣ",
        "name_sa": "नामकरणम्",
        "category_kn": "ಸಂಸ್ಕಾರ",
        "category_sa": "संस्कारः"
    },
    {
        "id": "b1c0c3fc-72c3-4f2d-ae58-c061977faf65",
        "name": "Aksharabhyasa",
        "amount": 501,
        "description": "Sacred initiation into learning for the child, performed in the divine presence of Sri Saraswati.",
        "category": "Samskara",
        "image": null,
        "order": 0,
        "description_kn": "ಶ್ರೀ ಸರಸ್ವತಿಯ ದಿವ್ಯ ಸನ್ನಿಧಿಯಲ್ಲಿ ಮಗುವಿಗೆ ವಿದ್ಯಾರಂಭದ ಪವಿತ್ರ ದೀಕ್ಷೆ.",
        "description_sa": "श्रीसरस्वत्याः दिव्यसन्निधौ बालस्य विद्यारम्भस्य पवित्रदीक्षा।",
        "name_kn": "ಅಕ್ಷರಾಭ್ಯಾಸ",
        "name_sa": "अक्षराभ्यासः",
        "category_kn": "ಸಂಸ್ಕಾರ",
        "category_sa": "संस्कारः"
    },
    {
        "id": "784ad53b-e147-4968-a16f-e3f5c1b045f0",
        "name": "Bruhathi Sponsorship",
        "amount": 11001,
        "description": "Support the vedic scholars of the Bruhathi paatashala studying under the Matha.",
        "category": "Vidwat",
        "image": null,
        "order": 0,
        "description_kn": "ಮಠದ ಅಡಿಯಲ್ಲಿ ಅಧ್ಯಯನ ಮಾಡುವ ಬೃಹತೀ ಪಾಠಶಾಲೆಯ ವೈದಿಕ ವಿದ್ವಾಂಸರಿಗೆ ಬೆಂಬಲ.",
        "description_sa": "मठाधीने बृहतीपाठशालायाम् अधीयानानां वैदिकविदुषां साहाय्यम्।",
        "name_kn": "ಬೃಹತೀ ಪ್ರಾಯೋಜಕತ್ವ",
        "name_sa": "बृहती-प्रायोजनम्",
        "category_kn": "ವಿದ್ವತ್",
        "category_sa": "विद्वत्"
    }
];
